import { TranscriptDetail, TranscriptSummary } from '../types/api';

export type WhisperSegmentSummary = {
  segment_count?: number;
  duration_ms?: number;
  language?: string;
  rtf?: number;
  input_files?: string[];
  no_speech_detected?: boolean;
  job_meta?: {
    audio_duration_sec?: number;
    [key: string]: unknown;
  };
};

type TranscriptLike = Pick<TranscriptSummary, 'transcript_text' | 'no_speech_detected'> & {
  segments_summary?: Record<string, unknown> | null;
};

export const isWhisperBatchEngine = (engine?: string | null) =>
  (engine || '').toLowerCase() === 'whisper-batch';

export const getWhisperSegmentSummary = (
  transcript?: TranscriptLike,
): WhisperSegmentSummary | undefined => {
  return transcript?.segments_summary as WhisperSegmentSummary | undefined;
};

export const isNoSpeechDetected = (transcript?: TranscriptLike): boolean => {
  if (!transcript) {
    return false;
  }
  if (transcript.no_speech_detected) {
    return true;
  }
  const summary = getWhisperSegmentSummary(transcript);
  if (summary?.no_speech_detected === true) {
    return true;
  }
  const transcriptText = transcript.transcript_text?.trim();
  if (transcriptText) {
    return false;
  }
  return summary?.segment_count === 0 && summary?.job_meta?.audio_duration_sec === 0;
};

export const getWhisperTranscriptMessage = (
  transcript?: TranscriptLike,
): string => {
  if (transcript?.transcript_text?.trim()) {
    return transcript.transcript_text;
  }
  if (isNoSpeechDetected(transcript)) {
    return '音声は記録されましたが、認識できる音声区間はありませんでした';
  }
  return '音声認識結果を処理中...';
};

export const hasRecognizedSpeech = (transcript?: TranscriptLike): boolean => {
  return Boolean(transcript?.transcript_text?.trim());
};

export const hasTranscriptSegments = (detail?: TranscriptDetail): boolean => {
  return Boolean(detail?.segments?.length);
};
